import * as _ from 'lodash';
import { SidebarStates } from './States/sidebar.states';
import { ShowingsStates } from './States/showings.states';
import { ListingsStates } from './States/listings.states';
import { ReportsStates } from './States/reports.states';
import { AuthStates } from './States/auth.states';
import { PreSaleStates } from './States/presale.states';
import { RifoExlusiveStates } from './States/rifo.exlusive';
import { LPCreatePageStates } from './States/l.p.create.page.states';
import { LPListStates } from './States/l.p.list.states';
import { LPMobileStates } from './States/l.p.mobile.states';

export namespace MutationsManager {
    export class Manager {
        public mutations: any = {};
        public constructor() { }
        /**
         * register
        mutation: any     */
        public register(newMutations: any) {
            _.mixin(this.mutations, newMutations);
        }
    }

    export function factory(): Manager {
        const manager = new Manager();
        manager.register({
            increment(state: any) {
                state.count++;
            },
        });
        manager.register(SidebarStates.mutations());
        manager.register(ShowingsStates.mutations());
        manager.register(ListingsStates.mutations());
        manager.register(ReportsStates.mutations());
        manager.register(AuthStates.mutations());
        manager.register(PreSaleStates.mutations());
        manager.register(RifoExlusiveStates.mutations());
        manager.register(LPCreatePageStates.mutations());
        manager.register(LPListStates.mutations());
        manager.register(LPMobileStates.mutations());
        return manager;
    }
}
